import React, { useState, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    InputLabel,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Chip,
    List,
    ListItem,
    ListSubheader,
    Typography,
    ListItemButton,
} from '@mui/material';

import { useNavigate, useLocation } from "react-router-dom";

import { useTranslations } from '../../hooks/useTranslations';
import { useSystemRoutes, routeTypes } from "../../hooks/useSystemRoutes";

import { getSettingConfigs, getSettingTranslations } from "../../configs/settingConfigs"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const RenderMenuItem = ({ item, cssKey, location, index, onClick }) => {

    // check the current path name is selected
    // console.log('location', location)
    let currentPathName = location.pathname;

    let matchKeywords = item?.pathKeywords

    let isSelected = false

    matchKeywords.forEach(i => {
        let result = currentPathName.match(new RegExp(i, 'gi'))
        if (result) {
            isSelected = true
        }
        // console.log('result', i, currentPathName, result)
    })

    // if (isSelected === false && item?.isDefault === true) {
    //     isSelected = true
    // }

    return (
        <ListItem
            key={`item-${cssKey}-${index}`}
            disablePadding
        >
            <ListItemButton
                sx={{
                    pl: 2,
                    borderRadius: 2
                }}
                onClick={() => {
                    onClick({ item })
                }}
                selected={isSelected}
            >
                <Typography
                    variant="subtitle1"
                    sx={{
                        lineHeight: 1.2
                    }}
                >
                    {item?.display}
                </Typography>
            </ListItemButton>
        </ListItem>
    )
}

const RenderMenu = ({
    title,
    location,
    cssKey,
    menus,
    onClick
}) => {

    return (
        <List
            sx={{
                // width: '100%',
                // maxWidth: 360,
                // bgcolor: 'background.paper',
                position: 'relative',
                overflow: 'auto',
                // maxHeight: 300,
                // '& ul': { padding: 0 },
                mb: 1
            }}
            disablePadding
            subheader={<li />}
        >
            {/* <li key={`section-${key}`}>
                <ul> */}
            <ListSubheader
                sx={{
                    // backgroundColor: 'red',
                    backgroundColor: 'transparent',
                    p: 0,
                }}
            >
                <Typography
                    variant="subtitle2"
                    sx={{
                        textTransform: 'uppercase'
                    }}
                >
                    {`${title}`}
                </Typography>
            </ListSubheader>
            <Divider sx={{ my: 1 }} />
            {
                menus.map((item, index) => (
                    <RenderMenuItem
                        key={index}
                        cssKey={cssKey}
                        location={location}
                        index={index}
                        item={item}
                        onClick={onClick}
                    />
                ))
            }
            {/* </ul>
            </li> */}
        </List>
    )
}

function SettingFrame({
    routeType,
    children
}) {

    const { t } = useTranslations({ ns: ["common", "sidebar"] })

    const { t: tMenus, getTranslations } = useTranslations(getSettingTranslations())

    const location = useLocation();

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    // const { getHtmlHead } = useSystemHead(routeType)

    const { basicConfigs, advancedConfigs, customConfigs } = getSettingConfigs({ t: tMenus })

    const handleMenuClick = ({ item }) => {

        navigate(getRoute(`settings/${item.entryUrl}`))
    }

    const basicSettings = {
        title: t(`basicSettings`),
        menu: basicConfigs
    }

    const advancedSettings = {
        title: t(`advancedSettings`),
        menu: advancedConfigs
    }

    const customSettings = {
        title: t(`customSettings`),
        menu: customConfigs
    }

    return (
        <Box>
            {/* {
                getHtmlHead({ routeType, title: "Setting" })
            } */}

            {/* <CommonBreadcumbs
                routeType={routeType}
                pageTitle={'Settings'}
                breadcrumbs={[
                    {
                        displayText: 'Settings',
                        props: {
                            // href: getRoute("users/drivers")
                        }
                    },
                ]}
            /> */}

            {/* {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            } */}

            <Grid container spacing={1}>
                <Grid item sm={12} xs={12} md={2}>

                    <Typography
                        variant="h4"
                    >
                        {t("settings")}
                    </Typography>

                    <RenderMenu
                        routeType={routeType}
                        location={location}
                        cssKey={`basic`}
                        title={basicSettings.title}
                        menus={basicSettings.menu}
                        onClick={handleMenuClick}
                    />

                    <RenderMenu
                        routeType={routeType}
                        location={location}
                        cssKey={`advanced`}
                        title={advancedSettings.title}
                        menus={advancedSettings.menu}
                        onClick={handleMenuClick}
                    />

                    {
                        customSettings.menu.length > 0 &&

                        <RenderMenu
                            routeType={routeType}
                            location={location}
                            cssKey={`custom`}
                            title={customSettings?.title}
                            menus={customSettings?.menu}
                            onClick={handleMenuClick}
                        />

                    }

                </Grid>
                <Grid item sm={12} xs={12} md={10}>

                    {/* <StyledCard> */}

                    {children}

                    {/* </StyledCard> */}

                </Grid>
            </Grid>

        </Box>
    )
}

export default SettingFrame